import React from "react";
import Pagination from "@atlaskit/pagination";

import { Grid } from "../../UI/Grid";
import { COLOR_MISCHKA, COLOR_WHITE } from "../../constants/styles";
import { usePageTablePaginationContext } from "./context";
import { DRAWER_WIDTH } from "../Nav/styles";

export const PageTablePagination = () => {
  const { pages, setPage } = usePageTablePaginationContext();

  const handlePageChange = (
    _: React.SyntheticEvent<Element, Event>,
    page: number
  ) => {
    setPage(page);
  };

  return (
    <Grid
      container
      py={1}
      px={4}
      left={DRAWER_WIDTH}
      right={0}
      bottom={0}
      zIndex={1}
      width="auto"
      position="fixed"
      alignItems="center"
      bgcolor={COLOR_WHITE}
      borderTop={`1px solid ${COLOR_MISCHKA}`}
      justifyContent="center"
    >
      {/* <Grid item>
        Showing {page * 10} of {total} rows
      </Grid> */}
      <Grid item>
        <Pagination pages={pages} onChange={handlePageChange} />
      </Grid>
      {/* <Grid item /> */}
    </Grid>
  );
};
